<template>
  <div id="app" v-cloak>
    <router-view ></router-view>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import * as routerConfig from './router/config.js'

export default {
  computed: {
      ...mapGetters(['headMenuTree','isShowAppStore','userInfo'])
  },
  data(){
    return{
    }
  },
  created(){
    this.initData();
  },
  methods:{
    initData(){
      //是否显示应用市场
      if(process.env.NODE_ENV == 'development'){
        this.$store.state.app.isShowAppStore=true;
      }else if(process.env.NODE_ENV == 'production'){
        if(process.env.VUE_APP_NAME=="alpha"||process.env.VUE_APP_NAME=="build2"){
          this.$store.state.app.isShowAppStore=true;
        }else{
          this.$store.state.app.isShowAppStore=false;
        }
      }else{
        this.$store.state.app.isShowAppStore=false;
      }
      if(this.isShowAppStore){
        // this.$router.addRoutes(routerConfig.router_other);//调用addRoutes添加路由
      }
    }
  }
}
</script>

<style lang="less">
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
html{
  font-family:Microsoft YaHei;
}
body{
  font-family:Microsoft YaHei;
  min-width: 1280px;
}
input {font-family: Microsoft YaHei;}
ol, ul {
	list-style: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
  @import 'assets/css/cssreset.css';
  body,html {
    font-family: Microsoft YaHei;
    font-size: 14px;
    color: #333;
  }
  [v-cloak]{
    display: none !important;
  }

.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.general_banner_img_kuang{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  min-width: 1280px;
  height: 100%;
  font-size: 8rem;
  // background: hsl(240, 100%, 67%);
  color: hsl(0, 0%, 100%);
  position: relative;
}

  /*****************弹性盒模型全局class****************/
  .flex{
    display: flex;
  }
  .aCenter{
    justify-content: space-around;
  }
  .bCenter{
    justify-content: space-between;
  }
  .center{
    justify-content: center;
  }
  .column{
    flex-direction: column;
  }
  .middle{
    align-items: center;
  }

/************************文本溢出隐藏*******************/
  .text-overflow{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .info-details-new {
    cursor: pointer;
  }
  .el-tabs__nav {
    transform: translateX(-86px) !important;
  }




  // 通用样式修改
//抽屉标题

//吐司提示框
.el-message {
    min-width: 370px !important;
    height: 120px;
    // justify-content:start !important;
    // align-items: start !important;
    top: calc(50% - 47px) !important;
    border-width: 0.5px !important;
    padding: 15px 33px !important;
    border-radius: 3px;
    .el-message__icon {
        display: none;
    }
}

.el-message--success {
    background-color: #F0FFFA !important;
    border-color: rgba(37,174,132,1) !important;
}

.el-message--error {
    background:rgba(255,248,247,1) !important;
    border:1px solid rgba(255,101,85,1) !important;
}

//确定提示框
.el-message-box--center {
    padding-bottom: 0px !important;
}
.el-message-box {
    // display: inline-block;
    width: 315px !important;
    min-height: 231px;
    border: 0.5px solid #e3e3e3 !important;
    position: relative;
    .el-message-box__header {
        .el-message-box__title {
          font-size: 20px !important;
          color: #333 !important;
          font-weight:bold !important;
      }
    }
    .el-message-box__content {
       margin-bottom: 70px;
       font-size: 16px !important;
       color: #666 !important;
       padding-left: 37px !important;
       padding-right: 37px !important;
       padding-top: 20px !important;
       .el-message-box__message p {
            line-height: 30px;
       }
    }
    .el-message-box__btns {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 60px !important;
        padding: 0 !important;
        width: 100%;
        display: flex;
        .el-button {
            height: 100%;
            flex-grow: 1;
            border-radius: 0px !important;
            border: none !important;
            border-top: 0.5px solid #E3E3E3 !important;
            font-size: 20px !important;
            color: #666 !important;
        }
        .el-button--primary {
            font-size: 20px !important;
            color: #25AE84 !important;
            background-color: #fff !important;
            border: none !important;
            border-top: 0.5px solid #E3E3E3 !important;
            border-left: 0.5px solid #E3E3E3 !important;
        }

        .el-button--primary :hover {
            color: #108B65;
        }

        .el-button--primary :after {
            color: #25AE84;
        }
    }

    .el-message-box__btns button:hover {
        background-color: #F0FFFA !important;
    }

    .el-message-box__btns button:nth-child(2) {
        margin-left: 0px !important;
    }

    .el-message-box__btns button:nth-child(1):hover {
        color: #25AE84 !important;
    }

    .el-message-box__btns button:nth-child(2):hover {
        color: #108B65 !important;
    }
}

//输入框的提示
::-webkit-input-placeholder { /* WebKit, Blink, Edge */    color:    #ccc; }
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */   color:    #ccc; }
::-moz-placeholder { /* Mozilla Firefox 19+ */   color:    #ccc; }
:-ms-input-placeholder { /* Internet Explorer 10-11 */   color:    #ccc; }
</style>
